import React, {useEffect, useState} from "react";

export const ColorPromotionText = (text: string | undefined, refElement: HTMLDivElement | null, colorClass: string) => {
    const [render, setRender] = useState(false)
    useEffect(() => {
        setRender(true)
        const beginColorLetter = text && text.replace("*", `<span class=${colorClass}>`)
        const finishColorLetter = beginColorLetter && beginColorLetter.replace("**", `</span>`)
        if(refElement && finishColorLetter) {
            refElement.innerHTML = `${finishColorLetter}`
         }
    }, [render]);
}